import { EXERCISES_PATH } from '../../constants'
import { createSelector } from 'reselect'
import {
  compactObjectUtil,
  getObjectUtil
  , pickObjectUtil
} from 'packages/src'

const getDomainMapExercisesSelect = createSelector(state => getObjectUtil(
  state,
  EXERCISES_PATH.DATA
),
state => getObjectUtil(state, EXERCISES_PATH.ALL_DATA),
(domainMap, domainListData) => {
  return {
    ...compactObjectUtil(pickObjectUtil(domainMap, domainListData))
  }
}
)

export default getDomainMapExercisesSelect
